import { WeekDay } from "../../../types/generic.types";
import { SlotsMap } from "../types";

export const initialSlots: any = [
  [WeekDay.saturday, new Set()],
  [WeekDay.sunday, new Set()],
  [WeekDay.monday, new Set()],
  [WeekDay.tuesday, new Set()],
  [WeekDay.wednesday, new Set()],
  [WeekDay.thursday, new Set()],
  [WeekDay.friday, new Set()],
];

export const createCourtMinSlotTime = (count: number, stepInSeconds = 15 * 60) => {
  return (
    Array(count)
      .fill(null)
      // @ts-ignore
      .map((el, index) => {
        const val = stepInSeconds + index * stepInSeconds;
        return {
          id: val,
          name: val / 60 / 60 > 1 ? `${val / 60 / 60} hours` : `${val / 60} minutes`,
        };
      })
  );
};

export const getDayName = (date: Date, lowerCased = true) => {
  const daysNamesArray = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return (lowerCased ? daysNamesArray[date.getDay()].toLowerCase() : daysNamesArray[date.getDay()]) as WeekDay;
};

export const disableSubmitBtn = (slots: SlotsMap): boolean => {
  for (const entry of slots) {
    if (entry[1].size > 0) return false;
  }
  return true;
};
